import React from 'react';

import { OverviewSlider } from './leaderboard-overview/overview-slider';
import { TextField } from '@mui/material';

const MAX_COLLINEARITY_TOOLTIP =
  'Maximum correlation of any two features on the list';
const CONFIDENCE_TOOLTIP =
  'The probability that a feature is better than a random feature';

interface FeatureLeaderboardOverviewProps {
  isWithAssessment: boolean;
  maxCollinearity: number;
  setMaxCollinearity: (v: number) => void;
  confidence: number;
  setConfidence: (v: number) => void;
  setSearch: (s: string) => void;
}

export const FeatureLeaderboardOverview: React.FC<
  FeatureLeaderboardOverviewProps
> = ({
  isWithAssessment,
  confidence,
  setConfidence,
  maxCollinearity,
  setMaxCollinearity,
  setSearch,
}) => {
  const [searchPhrase, setSearchPhrase] = React.useState(() => '');

  return (
    <div style={{ display: 'flex' }}>
      {isWithAssessment ? (
        <>
          <OverviewSlider
            value={maxCollinearity}
            setValue={setMaxCollinearity}
            label="Max collinearity:"
            labelTooltip={MAX_COLLINEARITY_TOOLTIP}
          />
          <OverviewSlider
            value={confidence}
            setValue={setConfidence}
            label="Confidence:"
            labelTooltip={CONFIDENCE_TOOLTIP}
          />
        </>
      ) : null}

      <span style={{ marginLeft: 'auto', width: '30%' }}>
        <TextField
          sx={{ top: '-8px', width: '100%' }}
          size="small"
          label="Search"
          type="search"
          variant="standard"
          margin="dense"
          value={searchPhrase}
          onChange={e => {
            setSearchPhrase(e.target.value);
            setSearch(e.target.value);
          }}
        />
      </span>
    </div>
  );
};
